import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCCustomFilters(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 501.491 400.001">
            <g id="Custom_Filters" transform="translate(-5.15 -53.599)">
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="245.91"
                    cy="40.69"
                    rx="245.91"
                    ry="40.69"
                    transform="translate(5.15 372.22)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M342.32,413.62H463.8a7,7,0,0,0,7-7V224.67a7,7,0,0,0-7-7l-122.45-.32a7,7,0,0,0-7,7l1,182.27a7,7,0,0,0,6.97,7Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M348.28,226.3l108.61.67a7.13,7.13,0,0,1,7.08,7.15l-.76,163.3a7.11,7.11,0,0,1-7,7.08l-105.53,1.93a7.13,7.13,0,0,1-7.25-7l-2.32-165.89a7.12,7.12,0,0,1,7.17-7.24Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_1"
                    data-name="Rectangle 1"
                    width="87.95"
                    height="5.01"
                    rx="2.13"
                    transform="translate(352.69 233.32)"
                    fill="#707272"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M362,244.87h0a2.12,2.12,0,0,0,2.09,2l73.19,1.34a2.13,2.13,0,0,0,2.17-2.13v-.17a2.13,2.13,0,0,0-2.1-2.13l-73.19-1.16a2.13,2.13,0,0,0-2.16,2.25Z"
                    fill="#707272"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M354.56,400.36a5.59,5.59,0,0,1-5.57-5.48l-2.38-133.56a5.59,5.59,0,0,1,5.47-5.67l98.82-1.92h.1a5.56,5.56,0,0,1,5.57,5.47l2.55,134.29a5.57,5.57,0,0,1-5.51,5.68l-99,1.19ZM451,254.76h-.09l-98.82,1.93a4.54,4.54,0,0,0-4.45,4.62L350,394.86a4.56,4.56,0,0,0,4.54,4.46h.05l99-1.19a4.54,4.54,0,0,0,4.48-4.62l-2.55-134.29a4.54,4.54,0,0,0-4.53-4.46Z"
                    fill="#707272"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M456.22,268.2H348.41a.52.52,0,0,1-.52-.52.53.53,0,0,1,.52-.52H456.22a.52.52,0,0,1,0,1.04Z"
                    fill="#707272"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M45.42,413.62H205.76c5.11,0,9.25-1.58,9.25-3.53V318.56c0-1.94-4.13-3.52-9.23-3.53l-161.62-.16c-5.14,0-9.31,1.58-9.28,3.54l1.28,91.7C36.19,412.05,40.32,413.62,45.42,413.62Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M53.27,319.38l143.37.34c5.19,0,9.36,1.62,9.34,3.6l-1,82.15c0,1.95-4.12,3.53-9.22,3.56l-139.3,1c-5.21,0-9.5-1.54-9.57-3.53L43.82,323C43.75,321,48,319.37,53.27,319.38Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M59.1,324v.37c0,.59,1.26,1.07,2.81,1.07H172.38c1.55,0,2.81-.48,2.81-1.07V324c0-.6-1.26-1.08-2.81-1.08H61.91C60.36,322.91,59.1,323.39,59.1,324Z"
                    fill="#c0cfeb"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M71.43,328.72h0c.08.57,1.28,1,2.75,1l96.61.67c1.57,0,2.86-.47,2.86-1.07v-.09c0-.58-1.23-1.06-2.76-1.07l-96.61-.58C72.65,327.59,71.34,328.1,71.43,328.72Z"
                    fill="#8193ca"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M61.57,407.21c-3.43,0-7.1-1-7.19-3L51.24,337h0a1.77,1.77,0,0,1,.54-1.29c1-1.1,3.6-1.82,6.52-1.84l130.44-1c3.47,0,7.23,1,7.32,3l3.37,67.56a1.79,1.79,0,0,1-.54,1.3c-1,1.1-3.63,1.83-6.57,1.84l-130.67.6ZM52.28,337l3.13,67.19c0,.85,2.4,2,6.15,2h.09l130.66-.6c3,0,5.14-.8,5.83-1.52a.74.74,0,0,0,.25-.53L195,336c0-.84-2.4-2-6.15-2h-.13L58.28,335c-3,0-5.1.8-5.78,1.52a.74.74,0,0,0-.25.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M195.76,340.72H53.45a.52.52,0,1,1,0-1H195.76a.52.52,0,1,1,0,1Z"
                    fill="#707272"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M231.2,340.31l-6.78,60.86h78.73L292.9,340.31Z"
                    fill="#707272"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M98.94,190.35V329.74a21.14,21.14,0,0,0,20.61,21.14c50.91,1.32,229,4.5,277.44,3.79a15.57,15.57,0,0,0,15.32-15.12c.94-32.38,2.46-110.25-3.16-146.41a16,16,0,0,0-15.31-13.55c-42.66-1.36-231.43-5.7-279.87-4.61A15.38,15.38,0,0,0,98.94,190.35Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M107.69,189.67V322.11a12.26,12.26,0,0,0,12.07,12.25L390,337.7a11.93,11.93,0,0,0,12.1-11.88l.46-131.25a8.72,8.72,0,0,0-8.51-8.75l-276.7-5.59a9.44,9.44,0,0,0-9.66,9.44Z"
                    fill="#fff"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M404.16,343h0l-296.47-5a.27.27,0,0,1-.26-.27.26.26,0,0,1,.26-.25h0l296.46,5.05a.26.26,0,0,1,.26.26.27.27,0,0,1-.25.21Z"
                    fill="#fff"
                    opacity="0.65"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M258.85,349.18a3.35,3.35,0,1,1,3.34-3.35,3.35,3.35,0,0,1-3.34,3.35Zm0-6.17a2.816,2.816,0,1,0,0-.01Z"
                    fill="#fff"
                    opacity="0.65"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M374.86,223.59l-247.82,3a6.72,6.72,0,0,0-6.63,6.68l-.65,101.1,262.32,3.34.71-106.23a7.83,7.83,0,0,0-7.93-7.89Z"
                    fill="#e4e3e3"
                />
                <rect
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    width="11.96"
                    height="47.61"
                    transform="translate(134.58 284.48)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="11.96"
                    height="31.25"
                    transform="translate(154.56 300.84)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="11.96"
                    height="71.69"
                    transform="translate(174.54 260.4)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="11.96"
                    height="17.22"
                    transform="translate(194.52 314.87)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_6"
                    data-name="Rectangle 6"
                    width="11.96"
                    height="62.11"
                    transform="translate(214.5 269.98)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_7"
                    data-name="Rectangle 7"
                    width="11.96"
                    height="51.35"
                    transform="translate(234.48 280.74)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_8"
                    data-name="Rectangle 8"
                    width="11.96"
                    height="39.67"
                    transform="translate(254.46 292.42)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_9"
                    data-name="Rectangle 9"
                    width="11.96"
                    height="86.19"
                    transform="translate(274.44 245.9)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_10"
                    data-name="Rectangle 10"
                    width="11.96"
                    height="77.07"
                    transform="translate(294.43 255.02)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_11"
                    data-name="Rectangle 11"
                    width="11.96"
                    height="63.28"
                    transform="translate(314.41 268.81)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_12"
                    data-name="Rectangle 12"
                    width="11.96"
                    height="15.62"
                    transform="translate(334.39 316.47)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_13"
                    data-name="Rectangle 13"
                    width="11.96"
                    height="45.98"
                    transform="translate(354.37 286.11)"
                    fill="#fff"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M211.9,397.63a.27.27,0,0,1-.25-.18,165.34,165.34,0,0,0-26.46-47.56,129.13,129.13,0,0,0-15.67-16.76.26.26,0,0,1,0-.37.25.25,0,0,1,.36,0,129,129,0,0,1,15.73,16.83,165.279,165.279,0,0,1,26.56,47.72.25.25,0,0,1-.16.33Z"
                    fill="#707272"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M320.11,413.62H204.88c-3.13,0-5.48-2.23-4.88-4.62l1.48-5.85c.45-1.76,2.38-3,4.68-3.12l111.09-3.47c2.4-.07,4.52,1.2,5.05,3l2.66,9.32C325.65,411.32,323.29,413.62,320.11,413.62Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M266.91,401.5a.26.26,0,1,1,0-.52l4.76-.07a.27.27,0,0,1,.26.26.26.26,0,0,1-.26.26Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M204.27,410.28h0a.27.27,0,0,1-.22-.3l.68-4.25a4.64,4.64,0,0,1,4.51-3.91l50.49-.74a.27.27,0,0,1,.26.26.25.25,0,0,1-.25.26l-50.49.74a4.12,4.12,0,0,0-4,3.47l-.68,4.25a.26.26,0,0,1-.3.22Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M378.38,195.42l-250.07-3.88a5.32,5.32,0,0,0-5.4,5.19l-.5,20.92a5.31,5.31,0,0,0,5.4,5.44l250.57-4a5.32,5.32,0,0,0,5.23-5.32v-13a5.31,5.31,0,0,0-5.23-5.35Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M265.39,202.9H236.73l7.77,44.29a2.91,2.91,0,0,0,1.83,2.22,12.52,12.52,0,0,0,9.25.24,3.37,3.37,0,0,0,2-2.55Z"
                    fill="#707272"
                />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M303.32,140.63l-38.72-2.37L199,140.63v2.74a7,7,0,0,0,1.13,3.78l36.64,55.75a46.82,46.82,0,0,0,28.82,0l36.64-55.75a6.89,6.89,0,0,0,1.13-3.78Z"
                    fill="#707272"
                />
                <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M303.32,140.63c-33.33,4-68.23,3.68-104.36,0v-3.56a3.45,3.45,0,0,1,3.35-3.44L299.78,131a3.44,3.44,0,0,1,3.54,3.44Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_26"
                    data-name="Path 26"
                    d="M238.57,199.93a.54.54,0,0,1-.44-.24L206.75,150a1.85,1.85,0,0,1,1.75-2.83c9.21.9,41.48,3.54,70-.29a.519.519,0,1,1,.13,1.03c-28.64,3.84-61,1.19-70.24.29a.81.81,0,0,0-.78.38.83.83,0,0,0,0,.87L239,199.13a.53.53,0,0,1-.16.72A.6.6,0,0,1,238.57,199.93Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M251.3,248.8a11.57,11.57,0,0,1-3.41-.52,1.94,1.94,0,0,1-1.37-1.58L241.41,208a.51.51,0,0,1,.44-.58.52.52,0,0,1,.59.44l5.11,38.66a.9.9,0,0,0,.65.73,9.94,9.94,0,0,0,6.5-.15.533.533,0,1,1,.37,1,10.35,10.35,0,0,1-3.77.7Z"
                    fill="#e4e3e3"
                />
                <circle
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="31"
                    cy="31"
                    r="31"
                    transform="translate(131.834 110.88) rotate(-67.5)"
                    fill="#707272"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M143.76,92.85h0a.27.27,0,0,1-.25-.28,31.342,31.342,0,0,1,.42-3.62.26.26,0,0,1,.31-.21.25.25,0,0,1,.2.3A28.321,28.321,0,0,0,144,92.6.26.26,0,0,1,143.76,92.85Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_29"
                    data-name="Path 29"
                    d="M146.78,81.49a.27.27,0,0,1-.12,0,.25.25,0,0,1-.11-.35,28.75,28.75,0,0,1,25.79-15.88,29.26,29.26,0,0,1,5.21.47.26.26,0,1,1-.1.51,29,29,0,0,0-5.11-.46A28.24,28.24,0,0,0,147,81.35a.27.27,0,0,1-.22.14Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="26.24"
                    cy="26.24"
                    r="26.24"
                    transform="translate(135.898 94.783) rotate(-45)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M181.05,84.87c0,4.44-3.6,9.24-8.05,9.24s-8-4.8-8-9.24,3.6-7.6,8-7.6S181.05,80.43,181.05,84.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_31"
                    data-name="Path 31"
                    d="M163,111.21h19.64a4.75,4.75,0,0,0,4.52-3.3l1.06-3.31a4.74,4.74,0,0,0-2.87-5.9c-8-2.93-16.25-2.55-24.72.27a4.72,4.72,0,0,0-3,5.73l.81,3a4.77,4.77,0,0,0,4.56,3.51Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="31"
                    cy="31"
                    r="31"
                    transform="translate(213.763 71.072) rotate(-13.28)"
                    fill="#707272"
                />
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M222.48,92.85h0a.26.26,0,0,1-.25-.28,31.345,31.345,0,0,1,.42-3.62.26.26,0,0,1,.3-.21.25.25,0,0,1,.21.3,28.313,28.313,0,0,0-.41,3.56.26.26,0,0,1-.27.25Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M225.5,81.49a.27.27,0,0,1-.12,0,.26.26,0,0,1-.12-.35,28.77,28.77,0,0,1,25.8-15.88,29.26,29.26,0,0,1,5.21.47.26.26,0,0,1-.1.51,29,29,0,0,0-5.11-.46,28.23,28.23,0,0,0-25.33,15.6A.27.27,0,0,1,225.5,81.49Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="26.24"
                    cy="26.24"
                    r="26.24"
                    transform="translate(221.635 116.485) rotate(-80.78)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M259.77,84.87c0,4.44-3.61,9.24-8,9.24s-8-4.8-8-9.24,3.6-7.6,8-7.6S259.77,80.43,259.77,84.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M241.74,111.21h19.64a4.75,4.75,0,0,0,4.52-3.3l1.1-3.31a4.75,4.75,0,0,0-2.87-5.9c-8-2.93-16.25-2.55-24.72.27a4.72,4.72,0,0,0-3,5.73l.81,3a4.75,4.75,0,0,0,4.52,3.51Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="31"
                    cy="31"
                    r="31"
                    transform="translate(292.478 71.072) rotate(-13.28)"
                    fill="#707272"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M301.2,92.85h0a.26.26,0,0,1-.25-.27,27.44,27.44,0,0,1,.42-3.63.26.26,0,1,1,.51.09,28.316,28.316,0,0,0-.41,3.56.26.26,0,0,1-.27.25Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M304.21,81.49a.2.2,0,0,1-.11,0,.26.26,0,0,1-.12-.35,28.77,28.77,0,0,1,25.79-15.88,29.164,29.164,0,0,1,5.2.469.26.26,0,0,1,.216.3.25.25,0,0,1-.3.21,29.19,29.19,0,0,0-5.12-.46,28.26,28.26,0,0,0-25.33,15.6.24.24,0,0,1-.23.11Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="26.24"
                    cy="26.24"
                    r="26.24"
                    transform="translate(299.72 115.589) rotate(-79.1)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M338.48,84.87c0,4.44-3.6,9.24-8,9.24s-8.05-4.8-8.05-9.24,3.61-7.6,8.05-7.6S338.48,80.43,338.48,84.87Z"
                    fill="#707272"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M320.46,111.21h19.63a4.75,4.75,0,0,0,4.53-3.3l1.06-3.31a4.75,4.75,0,0,0-2.87-5.9c-8-2.93-16.26-2.55-24.72.27a4.72,4.72,0,0,0-3,5.73l.81,3A4.75,4.75,0,0,0,320.46,111.21Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_7"
                    data-name="Ellipse 7"
                    cx="37.65"
                    cy="37.65"
                    r="37.65"
                    transform="translate(210.229 327.988) rotate(-82.98)"
                    fill="#707272"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M217.48,293.62h0a.26.26,0,0,1-.25-.27,36.146,36.146,0,0,1,.51-4.4.26.26,0,0,1,.3-.21.27.27,0,0,1,.21.3,33.144,33.144,0,0,0-.5,4.34A.26.26,0,0,1,217.48,293.62Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M221.14,279.83h-.12a.26.26,0,0,1-.11-.35,35.07,35.07,0,0,1,37.6-18.69.26.26,0,1,1-.1.51,34.919,34.919,0,0,0-6.22-.56,34.37,34.37,0,0,0-30.82,19,.26.26,0,0,1-.23.09Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    cx="31.87"
                    cy="31.87"
                    r="31.87"
                    transform="translate(217.497 323.774) rotate(-82.98)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M262.77,284c0,5.39-4.38,11.22-9.77,11.22s-9.78-5.83-9.78-11.22,4.38-9.23,9.78-9.23S262.77,278.59,262.77,284Z"
                    fill="#707272"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M240.87,316h23.85a5.77,5.77,0,0,0,5.5-4l1.28-4a5.77,5.77,0,0,0-3.48-7.18c-9.71-3.55-19.74-3.09-30,.33a5.74,5.74,0,0,0-3.68,7l1,3.64A5.76,5.76,0,0,0,240.87,316Z"
                    fill="#707272"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M74.78,412.91c-2.55.22-7,.58-10.47.73a10,10,0,0,1-4-.39v.22a.72.72,0,0,0,.69.68,120.1,120.1,0,0,0,13.7,0,.51.51,0,0,0,.41-.77,3.54,3.54,0,0,0-.33-.47Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M64.31,413.64c3.49-.15,7.92-.51,10.47-.73-2.51-3.08-10.47-5.15-10.47-5.15H62.07a9.37,9.37,0,0,0-1.75,5.49A10,10,0,0,0,64.31,413.64Z"
                    fill="#707272"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M61.69,404.09l.21,4.16a1,1,0,0,0,.81.9A3.8,3.8,0,0,0,64.4,409a1.13,1.13,0,0,0,.75-.87l.73-4.05Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M32.51,413.61a2,2,0,0,1-1.82-1.34h0a1.44,1.44,0,0,0,1,1.64,6.27,6.27,0,0,0,2.68.42,2.65,2.65,0,0,0,2-.93h0a6.71,6.71,0,0,1-3.86.21Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_48"
                    data-name="Path 48"
                    d="M37.72,404.06H35.87c-2.83-.05-4.6,5.9-5.18,8.21a2,2,0,0,0,1.82,1.34,6.71,6.71,0,0,0,3.84-.21A17.67,17.67,0,0,0,39,406.74a2.34,2.34,0,0,0-1.28-2.68Z"
                    fill="#707272"
                />
                <path
                    id="Path_49"
                    data-name="Path 49"
                    d="M36.1,400.2l-1,4.1a1.09,1.09,0,0,0,.57,1.25,3.92,3.92,0,0,0,2.13.52.92.92,0,0,0,.76-.62l1.51-4.3Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M34.88,401.39c1.28,1.13,5.44,1.28,5.44,1.28,15-36,21.13-41.11,21.13-41.11-2.16,13.59-.34,43.67-.34,43.67,2.47,1.09,5.66,0,5.66,0a231.789,231.789,0,0,1,7.66-56.94c-10.14-.23-15.53-3.69-17.29-5.09C48.69,356.83,34.88,401.39,34.88,401.39Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M59.72,301.81c-1.92,9.57-1.23,26.7-.78,34.51.12,2.2-1.41,5.24-2.65,7.32a.65.65,0,0,0,.27.91,45.2,45.2,0,0,0,17.24,4.79,1.17,1.17,0,0,0,1.17-.87c6-22.56,13.06-37,13.06-37C80.28,299.12,59.72,301.81,59.72,301.81Z"
                    fill="#707272"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M62.48,360.71a.45.45,0,0,1-.25-.07.48.48,0,0,1-.16-.66A15.06,15.06,0,0,1,68,354.82a.48.48,0,1,1,.42.86,14.38,14.38,0,0,0-5.54,4.8.48.48,0,0,1-.4.23Z"
                    opacity="0.5"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M47.68,329.27a33,33,0,0,0,6.08,14.49l1.39-1.13a42.67,42.67,0,0,1-.69-13.84A16.651,16.651,0,0,0,47.68,329.27Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_54"
                    data-name="Path 54"
                    d="M61.86,313.62l-2.14-11.81s-14.32,10.94-12,27.46a16.651,16.651,0,0,1,6.78-.48C55.11,323.48,57.07,317.73,61.86,313.62Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_55"
                    data-name="Path 55"
                    d="M88,311.49,82.5,323.4c.9,7.18,4.76,10.29,8.92,11.48a25.24,25.24,0,0,1,1.86-7.75C88,321.64,88,311.49,88,311.49Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_56"
                    data-name="Path 56"
                    d="M93.28,327.13a25.24,25.24,0,0,0-1.86,7.75c11.11,4.31,14-4.05,14-4.05l-2-.36A11.536,11.536,0,0,1,93.28,327.13Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M82.94,296.8l-2.67,9.81a1.91,1.91,0,0,1-2.55,1.27,40.006,40.006,0,0,1-3.85-1.76,2.57,2.57,0,0,1-.9-3.7l5.54-8.27Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_58"
                    data-name="Path 58"
                    d="M110.55,324.27,42.18,349.15a5.24,5.24,0,0,0-3,7.09l.21.46a4.87,4.87,0,0,0,6.47,2.4l66.39-30.71Z"
                    fill="#707272"
                />
                <g id="Group_1" data-name="Group 1" opacity="0.1">
                    <ellipse
                        id="Ellipse_9"
                        data-name="Ellipse 9"
                        cx="33.75"
                        cy="33.14"
                        rx="33.75"
                        ry="33.14"
                        transform="translate(108.23 276.16)"
                        fill="#595a5a"
                    />
                </g>
                <path
                    id="Path_59"
                    data-name="Path 59"
                    d="M142,272.42c-20.74,0-37.56,16.51-37.56,36.88s16.82,36.88,37.56,36.88,37.56-16.51,37.56-36.88S162.72,272.42,142,272.42Zm0,68.34c-17.69,0-32-14.08-32-31.46s14.35-31.46,32-31.46,32,14.08,32,31.46S159.68,340.76,142,340.76Z"
                    fill="#707272"
                />
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M107.28,313.75a.14.14,0,0,1-.13-.12c-.11-.87-.19-1.75-.23-2.63a.13.13,0,1,1,.26-.01,20.739,20.739,0,0,0,.23,2.61.13.13,0,0,1-.11.15Zm.26-10.32h0a.13.13,0,0,1-.1-.15,33.37,33.37,0,0,1,2-6.91,34.62,34.62,0,0,1,12.7-15.51,35.7,35.7,0,0,1,38.7-.65.13.13,0,0,1-.14.22,35.24,35.24,0,0,0-18.7-5.34,34.71,34.71,0,0,0-32.31,21.38h0a34.161,34.161,0,0,0-2,6.86.12.12,0,0,1-.15.1Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_61"
                    data-name="Path 61"
                    d="M88.78,289.34c0,.17-2.23,11.2-2.23,11.2l-6.27-1.42.58-10.77S88.37,286.52,88.78,289.34Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_62"
                    data-name="Path 62"
                    d="M82.27,290.75l-.75,5.65a.74.74,0,0,0,0,.21c.07.44.4,1.95,1.92,1.52a7.13,7.13,0,0,1,3.52-.46.8.8,0,0,1,.54.92,34.5,34.5,0,0,1-1.44,5.14.8.8,0,0,1-1,.47,25.562,25.562,0,0,1-5.53-2.27.8.8,0,0,1-.39-.71c.06-1.43.23-5.76.09-7s-1.53-1.82-2.14-2.07a.76.76,0,0,1-.43-.43,2.07,2.07,0,0,1,1.38-3,.8.8,0,0,0,.51-1,2.06,2.06,0,0,1,1.16-2.85,2.9,2.9,0,0,1,3.47.83.79.79,0,0,0,1,.12.64.64,0,0,1,.71,0,.78.78,0,0,0,1.11-.34,2.38,2.38,0,0,1,2.76-1.37c2.81.48,3.13,3.59,2.39,5.41s-3.76,1.13-5.27.21c-1.15-.69-2.64,0-3.29.43a.76.76,0,0,0-.32.59Z"
                    fill="#707272"
                />
                <path
                    id="Path_63"
                    data-name="Path 63"
                    d="M79,296.31s1.15-3.24,0-4-2.95-.38-2.56,2C76.91,297.16,79,296.31,79,296.31Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M54.58,342.44l6.46-.53,2.8,2.58s-.66.91-2.73.39a29.59,29.59,0,0,0-4.91-.66s-2.86,1.29-2.89-1.12Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_65"
                    data-name="Path 65"
                    d="M104.64,332.36c.56.44,2.48-.47,3.65-1.1a1.37,1.37,0,0,0,.65-1.6c-.28-.89-.75-2-1.33-2.18C106.65,327.24,102.34,330.56,104.64,332.36Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M43.53,358h0c-2.09-.72-3.19-1.92-3.26-3.55a4,4,0,0,1,2.57-3.8l8.21-3.2a.13.13,0,1,1,.1.24l-8.21,3.2a3.69,3.69,0,0,0-2.41,3.55c.06,1.52,1.1,2.63,3.08,3.32a.12.12,0,0,1,.08.16.11.11,0,0,1-.16.08Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M53.59,346.72a.13.13,0,0,1-.05-.25l1.07-.41a.128.128,0,1,1,.09.24l-1.06.41Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M426,204.55s-22.29-39-25.3-42.65a2.32,2.32,0,0,0-2.08-.84l-6.21.74-7.3,15.79,12.16-7.08c-1.2,8.32,14.41,20.68,19.77,25.19a1.23,1.23,0,0,1,.1,1.79L415,199.73a24.57,24.57,0,0,0,12.13,6.9Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_69"
                    data-name="Path 69"
                    d="M416.2,198.52a3.14,3.14,0,0,0-1.83,1.66,1.39,1.39,0,0,0,.52,1.6c2.25,1.61,9.66,6.81,13.08,7.83a.4.4,0,0,0,.49-.46,12.38,12.38,0,0,0-2.58-4.7l.17.33a.47.47,0,0,1-.66.62C423.1,204.11,418.44,201.29,416.2,198.52Z"
                    fill="#707272"
                />
                <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M417.3,214.11s-3.38-8.06-3.42-8.09a141.691,141.691,0,0,0-12.73-38.8,2.34,2.34,0,0,0-1.87-1.24l-6.23-.53-10.34,14L396.05,175c-2.86,7.9,9.93,23.17,14.26,28.67a1.23,1.23,0,0,1-.27,1.78l-2.55,1.76A24.63,24.63,0,0,0,418,216.38Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_71"
                    data-name="Path 71"
                    d="M409,206.23a3.16,3.16,0,0,0-2.12,1.26,1.38,1.38,0,0,0,.18,1.67c1.88,2,8.09,8.62,11.23,10.31a.39.39,0,0,0,.57-.35,12.49,12.49,0,0,0-1.57-5.12l.09.35a.47.47,0,0,1-.77.48C414.58,213.11,410.59,209.4,409,206.23Z"
                    fill="#707272"
                />
                <path
                    id="Path_72"
                    data-name="Path 72"
                    d="M363.88,162.51s-5.64,8.38-6.1,12.21,1.56,5.15,7.46,5.63c17.56,1.45,26.21-3.81,26.21-3.81,1.21-7.66,2.06-9.61,12.09-13.77,0,0-12.69,1-15.24,0S363.88,162.51,363.88,162.51Z"
                    fill="#707272"
                />
                <path
                    id="Path_73"
                    data-name="Path 73"
                    d="M386.36,115.52s-3.93-4.64-8.1,1.06c-.76,1-3.66.18-4.73,2.34a2.73,2.73,0,0,1-3,1.52c-3-.56-8-.61-10.48,4.17-1.88,3.64-.43,5.77,1.45,7a3.06,3.06,0,0,1,1,4.12c-.8,1.36-.95,3.2,1.12,5.41,4.62,5,13.77-3.15,13.77-3.15l7.27-17.17Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M379.13,161.4a129.529,129.529,0,0,0,9.79-10.4,8.75,8.75,0,0,0,1.49-7.9,109.683,109.683,0,0,0-4.34-10.92c-.36-1.23-7.72-1.18-7.72-1.18s-14.49,9.4-20.18,25.33l6.39,2a74.181,74.181,0,0,1,7.52-10.38s-6.47,8.54-6.7,12Z"
                    fill="#707272"
                />
                <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M391.63,163.86l-4.93-5.36L381,160s-6.64,1-10.44,0l-3.8-1-8.59-2.67-1.35,3.81a2.3,2.3,0,0,0,.84,2.64,14.319,14.319,0,0,0,2.17,1.35c1.13.49,26.06.15,26.06.15Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M383.4,122.15l-4.94,9.2c.32,2,5.38,2.06,6.16.86a1.161,1.161,0,0,0,.16-.4l3-6.15c.13-.6-1.52-2.62-2.06-2.91l-2-1C383,121.3,386.12,121.27,383.4,122.15Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M393.42,120s.56,3.11-1.89,7.06-4.87,3.77-6.11,2.36a8.68,8.68,0,0,1-2-7.7C384.05,117.77,392.57,116,393.42,120Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_78"
                    data-name="Path 78"
                    d="M386.34,122.14s4-5.19,7-.66l-.05,1.56s4-.18,3.52-3.82-3.65-6.13-8.12-4.89-7.09,2.66-7.59,5.77,2,2.59,2,2.59,1-2.14,2.14-2.28S386,122,386,122Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_79"
                    data-name="Path 79"
                    d="M385.43,122s2.05-2.66.18-3.21-1.79,2.61-1.67,3.78Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M375.3,166h22.75a1,1,0,0,0,0-2h-22.7a1,1,0,0,0-.05,2Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M418.45,145.39h-18.9a3.6,3.6,0,0,0-3.26,2.06L387.56,166H411a2.2,2.2,0,0,0,2-1.39l6.77-17.14a1.51,1.51,0,0,0-1.32-2.08Z"
                    fill="#595a5a"
                />
                <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M405.13,154.88c-.41,1.28-.1,2.51.68,2.76s1.75-.57,2.16-1.84.1-2.51-.68-2.76S405.54,153.61,405.13,154.88Z"
                    fill="#e4e3e3"
                />
                <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M295.93,295.3a.52.52,0,0,1-.38-.17.51.51,0,0,1,0-.73l.58-.53a.52.52,0,0,1,.74.05.51.51,0,0,1-.05.73l-.58.52A.51.51,0,0,1,295.93,295.3Zm2-1.7a.53.53,0,0,1-.41-.19.52.52,0,0,1,.08-.73l.61-.49a.52.52,0,1,1,.65.81l-.61.49a.48.48,0,0,1-.34.11Zm2-1.59a.52.52,0,0,1-.31-.93l.64-.47a.52.52,0,0,1,.6.85l-.62.45a.54.54,0,0,1-.24.09Zm2.12-1.49a.52.52,0,0,1-.28-.95l.65-.43a.53.53,0,0,1,.72.16.51.51,0,0,1-.15.71c-.22.14-.44.28-.65.43a.51.51,0,0,1-.26.08Zm2.2-1.38a.53.53,0,0,1-.45-.25.54.54,0,0,1,.18-.72l.68-.39a.52.52,0,1,1,.52.89l-.67.39a.5.5,0,0,1-.23.08Zm2.25-1.28a.52.52,0,0,1-.24-1l.69-.37a.52.52,0,0,1,.48.92c-.23.12-.46.24-.68.37a.54.54,0,0,1-.22.08Zm2.31-1.18a.53.53,0,0,1-.47-.29.54.54,0,0,1,.24-.7l.71-.34a.53.53,0,0,1,.69.25.52.52,0,0,1-.25.69l-.69.34a.64.64,0,0,1-.2.05Zm2.36-1.08a.521.521,0,0,1-.21-1l.72-.3a.51.51,0,0,1,.68.27.52.52,0,0,1-.28.68l-.71.3a.53.53,0,0,1-.17.05Zm2.39-1a.5.5,0,0,1-.48-.33.52.52,0,0,1,.29-.67l.74-.28a.531.531,0,0,1,.36,1l-.72.28a.629.629,0,0,1-.16.01Zm2.43-.89a.52.52,0,0,1-.17-1l.74-.25a.527.527,0,0,1,.33,1l-.73.24a.47.47,0,0,1-.16.02Zm2.47-.8a.52.52,0,0,1-.16-1l.75-.23a.53.53,0,0,1,.65.35.52.52,0,0,1-.35.64l-.74.23Zm2.48-.72a.52.52,0,0,1-.13-1l.75-.2a.52.52,0,1,1,.27,1l-.75.19a.338.338,0,0,1-.08.02Zm2.51-.63a.52.52,0,0,1-.12-1l.77-.18a.52.52,0,0,1,.23,1l-.76.17ZM326,281a.5.5,0,0,1-.5-.41.51.51,0,0,1,.4-.61l.76-.16a.52.52,0,0,1,.61.41.51.51,0,0,1-.4.61l-.76.15Zm70.05-.15h-.21a.52.52,0,0,1,0-1.04h.78a.52.52,0,0,1,0,1.04Zm-2,0h-.78a.52.52,0,0,1-.51-.53.53.53,0,0,1,.52-.51H394a.52.52,0,0,1,0,1Zm4.41,0a.52.52,0,0,1,0-1h.77a.52.52,0,0,1,0,1h-.79Zm-7,0h-.78a.52.52,0,0,1-.51-.53.51.51,0,0,1,.54-.5h.77a.51.51,0,0,1,.51.53.52.52,0,0,1-.55.44Zm9.6,0a.52.52,0,0,1,0-1h.78a.51.51,0,0,1,.53.5.52.52,0,0,1-.5.54h-.78Zm-12.19,0h-.78a.52.52,0,0,1,0-1h.77a.53.53,0,0,1,.51.54.52.52,0,0,1-.52.33Zm14.78-.05a.52.52,0,0,1,0-1h.78a.516.516,0,0,1,.06,1.03l-.78.05Zm-17.37-.06h-.78a.52.52,0,0,1,.05-1h.78a.52.52,0,0,1,0,1Zm-57.7-.09a.52.52,0,0,1-.09-1l.77-.14a.52.52,0,0,1,.17,1l-.76.13Zm77.66,0a.52.52,0,0,1,0-1l.77-.06a.52.52,0,1,1,.08,1l-.77.06Zm-22.56,0h0l-.78-.05a.5.5,0,0,1-.49-.54.51.51,0,0,1,.54-.49h.78a.52.52,0,0,1,0,1Zm-2.59-.15h-.78a.52.52,0,0,1-.48-.55.51.51,0,0,1,.55-.49l.77.05a.52.52,0,0,1,0,1Zm27.73,0a.52.52,0,0,1-.05-1l.77-.08a.52.52,0,0,1,.11,1l-.78.08Zm-30.32-.1h0l-.78-.05a.52.52,0,0,1,.07-1h.78a.52.52,0,0,1,0,1Zm-47.37-.09a.52.52,0,0,1-.07-1l.77-.11a.53.53,0,0,1,.59.44.52.52,0,0,1-.44.59l-.77.11Zm44.78-.08h-.78a.52.52,0,0,1,.07-1l.78.05a.53.53,0,0,1,.48.56.52.52,0,0,1-.57.16Zm35.49,0a.522.522,0,0,1-.06-1.04l.77-.09a.52.52,0,0,1,.58.45.53.53,0,0,1-.45.58l-.78.09Zm-38.07-.17h0l-.78-.05a.52.52,0,0,1,.07-1l.78.05a.52.52,0,0,1,0,1Zm-39.63-.11a.52.52,0,0,1-.06-1l.77-.1a.52.52,0,1,1,.12,1l-.76.1Zm80.27-.06a.518.518,0,0,1-.07-1.03l.76-.12a.53.53,0,0,1,.6.43.54.54,0,0,1-.44.6l-.77.11Zm-43.23,0h0l-.77-.06a.52.52,0,0,1-.49-.55.53.53,0,0,1,.56-.48l.77.05a.53.53,0,0,1,.49.55.52.52,0,0,1-.58.28Zm-2.59-.17h0l-.78-.05a.52.52,0,1,1,.07-1l.77.05a.52.52,0,0,1,0,1Zm-31.87-.06a.52.52,0,0,1-.05-1l.77-.07a.52.52,0,1,1,.1,1l-.77.08Zm29.28-.1h-.78a.52.52,0,0,1-.48-.55.51.51,0,0,1,.54-.49l.78.05a.52.52,0,0,1,.49.55.53.53,0,0,1-.57.23Zm51-.08a.53.53,0,0,1-.51-.43.52.52,0,0,1,.43-.6l.76-.14a.52.52,0,0,1,.6.42.53.53,0,0,1-.42.61l-.77.13Zm-77.67-.06a.52.52,0,0,1,0-1l.78-.06a.53.53,0,0,1,.56.48.52.52,0,0,1-.48.55l-.78.06Zm24.11,0h-.77a.52.52,0,1,1,.05-1h.78a.51.51,0,0,1,.49.55.52.52,0,0,1-.55.23Zm-2.59-.14h-.78a.5.5,0,0,1-.49-.54.52.52,0,0,1,.54-.49h.78a.53.53,0,0,1,.49.55.52.52,0,0,1-.59.26Zm-18.93,0a.52.52,0,0,1,0-1h.78a.51.51,0,0,1,.54.49.52.52,0,0,1-.48.55h-.78Zm16.34-.08h-.78a.52.52,0,0,1,0-1h.78a.52.52,0,0,1,0,1ZM344,278.9a.52.52,0,0,1-.52-.5.53.53,0,0,1,.5-.54h.78a.52.52,0,0,1,0,1h-.78Zm11.16,0h-.77a.52.52,0,0,1,0-1h.78a.53.53,0,0,1,.51.53.52.52,0,0,1-.5.43Zm-8.56,0a.52.52,0,0,1,0-1h.78a.53.53,0,0,1,.53.51.52.52,0,0,1-.51.52h-.78Zm6,0h-.79a.52.52,0,0,1,0-1h.78a.52.52,0,0,1,0,1Zm66.47,0a.52.52,0,0,1-.51-.42.53.53,0,0,1,.41-.61l.76-.15a.5.5,0,0,1,.61.39.52.52,0,0,1-.4.62l-.76.16Zm-69.85,0a.53.53,0,0,1-.52-.51.52.52,0,0,1,.52-.52H350a.52.52,0,0,1,0,1.04h-.78Zm72.39-.54a.52.52,0,0,1-.12-1l.75-.18a.52.52,0,1,1,.25,1l-.76.18Zm2.51-.63a.519.519,0,0,1-.13-1.02l.75-.2a.51.51,0,0,1,.64.36.53.53,0,0,1-.37.64l-.75.2Zm2.5-.7a.53.53,0,0,1-.5-.37.52.52,0,0,1,.36-.65l.74-.22a.517.517,0,1,1,.3.99l-.75.23Zm2.48-.77a.51.51,0,0,1-.49-.36.5.5,0,0,1,.33-.65l.73-.25a.527.527,0,0,1,.33,1l-.74.24a.45.45,0,0,1-.17-.1Zm2.45-.84a.54.54,0,0,1-.49-.35.53.53,0,0,1,.32-.66l.72-.27a.53.53,0,0,1,.67.31.52.52,0,0,1-.31.67l-.73.27a.571.571,0,0,1-.19-.09Zm2.43-.91a.52.52,0,0,1-.19-1l.72-.28a.518.518,0,1,1,.39.96l-.73.29a.651.651,0,0,1-.17-.09Zm2.4-1a.521.521,0,0,1-.2-1l.71-.3a.52.52,0,1,1,.41.95l-.72.31a.649.649,0,0,1-.21-.06Zm2.38-1.05a.5.5,0,0,1-.47-.3.52.52,0,0,1,.25-.69l.7-.32a.52.52,0,0,1,.44.94l-.71.33a.52.52,0,0,1-.22-.06Zm2.34-1.11a.53.53,0,0,1-.47-.29.52.52,0,0,1,.24-.69l.69-.35a.53.53,0,0,1,.7.23.52.52,0,0,1-.23.7l-.7.35a.591.591,0,0,1-.24-.05Zm2.31-1.18a.54.54,0,0,1-.46-.27.52.52,0,0,1,.22-.7c.23-.12.46-.24.68-.37a.53.53,0,0,1,.71.22.52.52,0,0,1-.22.7l-.69.37a.489.489,0,0,1-.25-.05Zm2.28-1.24a.5.5,0,0,1-.45-.26.52.52,0,0,1,.2-.71l.67-.38a.53.53,0,0,1,.71.19.52.52,0,0,1-.2.71l-.68.39a.54.54,0,0,1-.26-.04Zm2.24-1.3a.52.52,0,0,1-.44-.25.51.51,0,0,1,.18-.71l.66-.4a.51.51,0,0,1,.71.17.52.52,0,0,1-.17.71l-.67.41a.52.52,0,0,1-.28-.03Zm2.21-1.36a.54.54,0,0,1-.44-.24.53.53,0,0,1,.16-.72l.65-.42a.52.52,0,0,1,.72.15.53.53,0,0,1-.15.72l-.66.42a.51.51,0,0,1-.29-.01Zm2.17-1.43a.52.52,0,0,1-.3-.95c.22-.14.43-.29.64-.44a.52.52,0,0,1,.72.14.51.51,0,0,1-.13.72l-.64.44a.52.52,0,0,1-.3-.01Zm2.12-1.49a.52.52,0,0,1-.3-.94l.62-.45a.522.522,0,1,1,.62.84l-.64.46a.53.53,0,0,1-.31-.01Zm2.08-1.54a.517.517,0,0,1-.31-.93l.61-.48a.52.52,0,0,1,.73.1.51.51,0,0,1-.09.72l-.62.48a.56.56,0,0,1-.33.01Zm2-1.61a.5.5,0,0,1-.4-.19.51.51,0,0,1,.08-.73l.6-.49a.52.52,0,1,1,.66.8l-.61.5a.51.51,0,0,1-.3.01Zm2-1.66a.52.52,0,0,1-.34-.91l.58-.51a.53.53,0,0,1,.74.06.52.52,0,0,1-.06.73l-.59.51a.5.5,0,0,1-.3.02Zm1.94-1.71a.52.52,0,0,1-.38-.17.51.51,0,0,1,0-.73l.57-.53a.53.53,0,0,1,.74,0,.52.52,0,0,1,0,.73l-.58.53a.52.52,0,0,1-.32.07Zm1.9-1.77a.55.55,0,0,1-.38-.16.52.52,0,0,1,0-.74c.18-.18.37-.35.55-.54a.52.52,0,0,1,.73,0,.53.53,0,0,1,0,.74l-.57.54a.5.5,0,0,1-.3.1Zm1.84-1.83a.55.55,0,0,1-.37-.15.52.52,0,0,1,0-.73l.54-.56a.52.52,0,1,1,.74.73l-.54.56a.53.53,0,0,1-.34.05Zm1.79-1.88a.53.53,0,0,1-.36-.13.52.52,0,0,1,0-.74l.52-.57a.52.52,0,0,1,.77.7l-.53.58a.51.51,0,0,1-.38.06Zm1.73-1.92a.55.55,0,0,1-.34-.13.51.51,0,0,1,0-.73l.06-.08.45-.51a.52.52,0,0,1,.73-.06.53.53,0,0,1,.05.74l-.45.52-.06.07a.53.53,0,0,1-.41.08Zm1.68-2a.5.5,0,0,1-.33-.12.51.51,0,0,1-.07-.73l.48-.6a.52.52,0,0,1,.73-.08.51.51,0,0,1,.08.73c-.16.2-.33.4-.49.61a.54.54,0,0,1-.37.11Zm1.61-2a.56.56,0,0,1-.32-.11.52.52,0,0,1-.09-.73l.47-.61a.51.51,0,0,1,.73-.1.52.52,0,0,1,.1.72l-.48.62a.49.49,0,0,1-.41.1Zm1.55-2.08a.49.49,0,0,1-.3-.1.51.51,0,0,1-.12-.72l.45-.63a.52.52,0,0,1,.72-.13.53.53,0,0,1,.13.73l-.43.5a.52.52,0,0,1-.42.24Zm1.49-2.13a.52.52,0,0,1-.43-.81l.43-.64a.52.52,0,1,1,.86.57l-.43.65a.52.52,0,0,1-.4.12Zm1.41-2.17a.53.53,0,0,1-.27-.08.52.52,0,0,1-.16-.72l.4-.65a.52.52,0,0,1,.89.54l-.42.67a.52.52,0,0,1-.41.13Zm1.35-2.22a.48.48,0,0,1-.26-.07.52.52,0,0,1-.19-.71l.39-.67a.52.52,0,1,1,.9.52l-.39.67a.52.52,0,0,1-.42.15Zm1.27-2.26a.5.5,0,0,1-.24-.06.52.52,0,0,1-.21-.71l.38-.8a.51.51,0,0,1,.7-.21.52.52,0,0,1,.22.7l-.37.69a.53.53,0,0,1-.45.28Zm1.2-2.3a.53.53,0,0,1-.24-.06.52.52,0,0,1-.23-.69c.12-.23.23-.47.34-.7a.521.521,0,1,1,.94.45l-.35.71a.52.52,0,0,1-.43.18Zm1.11-2.35a.57.57,0,0,1-.22,0,.52.52,0,0,1-.25-.69c.1-.24.21-.47.31-.71a.52.52,0,0,1,.69-.26.51.51,0,0,1,.26.68c-.1.24-.21.48-.32.72a.51.51,0,0,1-.44.15Zm1-2.38a.45.45,0,0,1-.2,0,.51.51,0,0,1-.28-.68l.29-.71a.535.535,0,0,1,1,.38c-.1.24-.19.49-.29.73a.53.53,0,0,1-.46.17Zm.94-2.42a.57.57,0,0,1-.18,0,.52.52,0,0,1-.31-.67c.09-.24.18-.48.26-.72a.528.528,0,1,1,1,.34l-.27.74a.5.5,0,0,1-.44.19Zm.84-2.45H485a.51.51,0,0,1-.33-.65c.08-.24.16-.49.23-.74a.53.53,0,0,1,.65-.34.51.51,0,0,1,.34.65c-.07.25-.15.5-.23.75a.53.53,0,0,1-.44.22Zm.75-2.48h-.14a.53.53,0,0,1-.36-.64l.21-.75a.52.52,0,0,1,.63-.37.53.53,0,0,1,.37.64l-.21.76a.51.51,0,0,1-.41.25Zm.65-2.52h-.12a.52.52,0,0,1-.38-.62c.06-.25.12-.5.17-.76a.52.52,0,0,1,.62-.39.51.51,0,0,1,.39.62c-.05.26-.11.51-.17.77a.53.53,0,0,1-.45.27Zm.55-2.53h-.1a.52.52,0,0,1-.41-.61,5.309,5.309,0,0,1,.14-.76.52.52,0,0,1,.6-.42.54.54,0,0,1,.42.61,4.316,4.316,0,0,1-.14.77.52.52,0,0,1-.45.27Zm.44-2.56h-.08a.53.53,0,0,1-.44-.59,6.322,6.322,0,0,1,.11-.76.52.52,0,1,1,1,.13,5.232,5.232,0,0,1-.11.78.52.52,0,0,1-.42.33Zm.32-2.57h-.05a.52.52,0,0,1-.46-.57c0-.26.05-.51.07-.77a.53.53,0,0,1,.56-.47.52.52,0,0,1,.47.57,2.944,2.944,0,0,1-.07.78.53.53,0,0,1-.46.35Zm.21-2.58h0a.54.54,0,0,1-.49-.55V206a.52.52,0,0,1,.54-.5.53.53,0,0,1,.5.54v.79a.52.52,0,0,1-.49.49Zm.09-2.59h0a.53.53,0,0,1-.52-.53v-.77a.52.52,0,0,1,.52-.52h0a.52.52,0,0,1,.52.52v.78a.52.52,0,0,1-.46.41Zm0-2.6a.53.53,0,0,1-.52-.5v-.77a.51.51,0,0,1,.49-.54.5.5,0,0,1,.54.49v.78a.52.52,0,0,1-.5.54Zm-.16-2.58a.53.53,0,0,1-.52-.48c0-.25-.05-.51-.07-.77a.51.51,0,0,1,.46-.56.5.5,0,0,1,.57.46,2.59,2.59,0,0,0,.08.78.52.52,0,0,1-.48.56Zm-.29-2.58a.53.53,0,0,1-.52-.45,4.8,4.8,0,0,0-.11-.76.52.52,0,0,1,.44-.59.51.51,0,0,1,.59.43,6.976,6.976,0,0,0,.11.78.52.52,0,0,1-.44.58Zm-.42-2.56a.53.53,0,0,1-.51-.43,3.953,3.953,0,0,0-.14-.75.52.52,0,0,1,1-.21c.06.26.11.52.15.77a.51.51,0,0,1-.41.61Zm-.53-2.54a.52.52,0,0,1-.51-.4l-.18-.75a.52.52,0,1,1,1-.25c.07.25.13.51.19.76a.52.52,0,0,1-.38.63Zm-.66-2.51a.52.52,0,0,1-.5-.37c-.07-.25-.15-.5-.22-.74a.51.51,0,0,1,.34-.65.52.52,0,0,1,.65.34c.08.25.15.51.22.76a.51.51,0,0,1-.35.64Zm-.79-2.47a.54.54,0,0,1-.49-.35c-.08-.25-.17-.49-.26-.73a.52.52,0,0,1,.98-.35c.09.24.18.49.26.74a.52.52,0,0,1-.49.69Zm-.9-2.43a.54.54,0,0,1-.49-.33c-.09-.24-.19-.48-.29-.71a.539.539,0,0,1,1-.4l.3.72a.54.54,0,0,1-.29.68.651.651,0,0,1-.21-.07Zm-1-2.39a.5.5,0,0,1-.47-.3l-.33-.69a.52.52,0,1,1,.93-.45c.11.23.23.47.34.71a.51.51,0,0,1-.47.73Zm-1.16-2.32a.5.5,0,0,1-.45-.28l-.37-.68a.51.51,0,0,1,.2-.7.52.52,0,0,1,.71.2c.13.23.25.47.37.7a.52.52,0,0,1-.21.7.54.54,0,0,1-.26-.05ZM481,177.49a.5.5,0,0,1-.44-.25l-.41-.66a.52.52,0,0,1,.17-.71.51.51,0,0,1,.71.16l.41.67a.51.51,0,0,1-.17.71.56.56,0,0,1-.27.08Zm-1.4-2.19a.54.54,0,0,1-.43-.23l-.43-.63a.51.51,0,0,1,.12-.72.53.53,0,0,1,.73.12c.15.22.3.43.44.65a.52.52,0,0,1-.13.72.55.55,0,0,1-.32.09Zm-1.51-2.1a.49.49,0,0,1-.41-.21l-.48-.6a.51.51,0,0,1,.09-.73.52.52,0,0,1,.73.08l.48.62a.52.52,0,0,1-.1.73.51.51,0,0,1-.33.11Zm-1.64-2a.51.51,0,0,1-.45-.2l-.51-.57a.53.53,0,0,1,0-.74.52.52,0,0,1,.74.05l.52.59a.52.52,0,0,1-.06.73.54.54,0,0,1-.26.12Zm-1.75-1.91a.53.53,0,0,1-.37-.15l-.54-.55a.51.51,0,0,1,0-.73.52.52,0,0,1,.74,0l.55.56a.52.52,0,0,1,0,.74.54.54,0,0,1-.4.11Zm-1.86-1.8a.51.51,0,0,1-.35-.13l-.58-.51a.52.52,0,0,1,0-.73.51.51,0,0,1,.73,0l.58.52a.51.51,0,0,1,0,.73.48.48,0,0,1-.4.1Zm-2-1.68a.5.5,0,0,1-.32-.11l-.6-.47a.521.521,0,1,1,.63-.83l.62.49a.52.52,0,0,1,.08.73.5.5,0,0,1-.41.17Zm-2.08-1.55a.52.52,0,0,1-.29-.09l-.64-.43a.53.53,0,0,1-.14-.72.52.52,0,0,1,.72-.14l.65.44a.52.52,0,0,1,.13.72.5.5,0,0,1-.43.2Zm-42.28-1.07a.53.53,0,0,1-.43-.22.52.52,0,0,1,.14-.72l.65-.44a.52.52,0,1,1,.57.86l-.63.43a.55.55,0,0,1-.3.07Zm40.1-.33a.48.48,0,0,1-.26-.07c-.22-.13-.44-.26-.67-.38a.524.524,0,1,1,.52-.91l.68.4a.52.52,0,0,1-.27,1Zm-37.91-1.05a.54.54,0,0,1-.45-.26.52.52,0,0,1,.19-.71l.69-.39a.54.54,0,0,1,.71.21.52.52,0,0,1-.21.7c-.23.12-.45.25-.67.38a.59.59,0,0,1-.26.05Zm35.64-.2a.46.46,0,0,1-.23-.05l-.69-.34a.521.521,0,1,1,.45-.94l.7.35a.52.52,0,0,1,.23.7.51.51,0,0,1-.46.26Zm-33.34-1a.512.512,0,0,1-.22-1c.23-.12.47-.23.71-.33a.521.521,0,1,1,.43.95l-.7.31a.44.44,0,0,1-.19.04Zm31-.08a.45.45,0,0,1-.2,0l-.71-.3a.5.5,0,0,1-.29-.67.51.51,0,0,1,.67-.29l.73.3a.53.53,0,0,1,.28.69.54.54,0,0,1-.45.24Zm-28.61-.93a.52.52,0,0,1-.18-1l.74-.28a.52.52,0,0,1,.66.32.51.51,0,0,1-.31.66l-.72.27a.579.579,0,0,1-.2,0Zm26.19,0a.511.511,0,0,1-.17,0l-.73-.24a.527.527,0,1,1,.33-1l.74.25a.53.53,0,0,1,.32.67.52.52,0,0,1-.5.28Zm-2.47-.78a.32.32,0,0,1-.14,0l-.74-.2a.52.52,0,0,1-.38-.63.53.53,0,0,1,.64-.37l.76.2a.52.52,0,0,1-.14,1Zm-21.26,0a.51.51,0,0,1-.14-1l.76-.22a.52.52,0,0,1,.63.37.51.51,0,0,1-.36.63l-.74.21a.39.39,0,0,1-.16-.07Zm18.74-.58h-.11l-.75-.15a.52.52,0,0,1-.41-.61.51.51,0,0,1,.6-.41l.78.15a.52.52,0,0,1,.4.62.53.53,0,0,1-.52.32Zm-16.23-.06a.52.52,0,0,1-.1-1l.77-.16a.53.53,0,0,1,.61.41.52.52,0,0,1-.41.61l-.76.15Zm13.68-.4h-.08l-.76-.11a.51.51,0,0,1-.45-.58.53.53,0,0,1,.58-.45l.78.11a.52.52,0,0,1-.07,1Zm-11.12,0a.52.52,0,0,1-.07-1l.78-.1a.51.51,0,0,1,.58.45.53.53,0,0,1-.46.58l-.76.1Zm8.54-.24h0l-.77-.06a.52.52,0,0,1,.06-1l.79.05a.52.52,0,0,1,0,1Zm-6,0a.52.52,0,0,1,0-1l.79-.05a.52.52,0,0,1,.05,1h-.76Zm3.37-.1h-.78a.52.52,0,0,1,0-1.04h.79a.54.54,0,0,1,.51.53.52.52,0,0,1-.49.35Z"
                    fill="#707272"
                />
                <circle
                    id="Ellipse_10"
                    data-name="Ellipse 10"
                    cx="9.87"
                    cy="9.87"
                    r="9.87"
                    transform="translate(399.32 67.4)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_11"
                    data-name="Ellipse 11"
                    cx="8.71"
                    cy="8.71"
                    r="8.71"
                    transform="translate(151.83 139.2)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_84"
                    data-name="Path 84"
                    d="M35.63,283.16H31.2v-4.42a.55.55,0,0,0-.55-.55h0a.55.55,0,0,0-.56.55v4.42H25.67a.57.57,0,0,0-.56.57.56.56,0,0,0,.56.55h4.42v4.43a.56.56,0,0,0,1.11,0h0v-4.43h4.43a.56.56,0,0,0,.56-.55.57.57,0,0,0-.56-.57Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_85"
                    data-name="Path 85"
                    d="M56.94,240.57h-7v-7a.87.87,0,0,0-.87-.87h0a.9.9,0,0,0-.9.87v7h-7a.9.9,0,0,0-.88.9.88.88,0,0,0,.88.87h7v7a.9.9,0,0,0,.9.88.87.87,0,0,0,.87-.88h0v-7h7a.88.88,0,0,0,.88-.87.9.9,0,0,0-.88-.9Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_86"
                    data-name="Path 86"
                    d="M505.47,264.55h-7v-7a.88.88,0,0,0-.88-.88h0a.9.9,0,0,0-.89.88v7h-7a.89.89,0,1,0,0,1.77h7v7a.89.89,0,0,0,.89.87.88.88,0,0,0,.88-.87h0v-7h7a.89.89,0,0,0,0-1.77Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_87"
                    data-name="Path 87"
                    d="M98.43,127.29H89.84v-8.57a1.05,1.05,0,0,0-1.06-1.06h0a1.07,1.07,0,0,0-1.09,1.06v8.57H79.13a1.08,1.08,0,1,0,0,2.16h8.56V138a1.08,1.08,0,0,0,1.09,1.07A1.06,1.06,0,0,0,89.84,138h0v-8.58h8.59a1.07,1.07,0,0,0,1.07-1.07,1.1,1.1,0,0,0-1.07-1.06Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
            </g>
        </SVGIcon>
    );
}
